<section>
  <div class="container">
    <div class="login-section card mx-auto p-5">
      <div class="header w-100 text-center mb-4">
        <img src="assets/Bergh-Bouwgroep-logo.png" height="64" />
      </div>
      <div class="title">
        <h6 class="mb-4 bergh-text-primary text-center">
          {{ lang.login.title }}
        </h6>
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="login()" id="loginForm">
        <div class="form-group">
          <label for="emailInput">{{ lang.login.emailLabel }}</label>
          <input
            type="email"
            [ngClass]="{
              'form-control': true,
              'is-invalid':
                loginForm.controls['email'].invalid &&
                loginForm.controls['email'].touched
            }"
            id="emailInput"
            formControlName="email"
            placeholder="{{ lang.login.emailPlaceholder }}"
          />
          <div class="invalid-feedback" id="emailError">Invalid email</div>
        </div>
        <div class="form-group">
          <label for="passwordInput">{{ lang.login.passwordLabel }}</label>
          <input
            type="password"
            [ngClass]="{
              'form-control': true,
              'is-invalid':
                loginForm.controls['password'].invalid &&
                loginForm.controls['password'].touched
            }"
            id="passwordInput"
            formControlName="password"
            placeholder="{{ lang.login.passwordPlaceholder }}"
          />
          <div class="invalid-feedback" id="passwordError">
            Ongeldig wachtwoord
          </div>
        </div>
        @if (loading) {
        <div class="loading d-flex align-items-center justify-content-center">
          <div class="spinner-border spinner-border-sm mr-2"></div>
          Inloggen...
        </div>
        }
        <div class="form-group mt-5">
          <button
            class="btn bergh-bg-secondary text-white w-100"
            type="submit"
            id="loginBtn"
            [disabled]="loginForm.invalid"
          >
            {{ lang.login.login }}
          </button>
        </div>
        <div class="footer text-center mt-4">
          <a
            routerLink="/forgot-password"
            class="bergh-text-secondary"
            id="forgotPasswordLink"
            >{{ lang.login.forgotPassword }}</a
          >
        </div>
      </form>
    </div>
  </div>
</section>
